<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PnWPvQ/tc-custom/9781638298861.jpg?1718183001603" alt="This image is the cover for the book The Adventures Of Finnigan"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Adventures Of Finnigan
      </h1>
      <p class="bookDescription body article font2">
        <p style="margin: 0cm 0cm 8pt; font-size: 15px; font-family: Calibri, sans-serif; text-align: justify;"><em><span style='font-family:"Times New Roman",serif;color:black;background:white;'>The Adventures of Finnigan</span></em><span style='font-family:"Times New Roman",serif;color:black;background:white;'> is a fictional story about a stray cat who finds a caring family to adopt her. She tries to do the right thing and fit in with the family but is not always successful</span><span style='font-family:"Times New Roman",serif;color:black;background:white;'> – s</span><span style='font-family:"Times New Roman",serif;color:black;background:white;'>ometimes with humorous results.</span><span style='font-family:"Times New Roman",serif;color:black;background:white;'> </span><span style='font-family:"Times New Roman",serif;color:black;background:white;'>Her new family looks after her and forgives her when she misbehaves.</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sandra McGregor
      </h2>
      
      <p class="authorDescription body article"><p style='margin-right:0cm;margin-left:0cm;font-size:16px;font-family:"Times New Roman",serif;'><span style="font-size:15px;color:#252525;">Sandra currently lives in Toronto, Ontario, Canada. She was a systems analyst prior to her career as an author.</span></p><p style='margin-right: 0cm; margin-left: 0cm; font-size: 16px; font-family: "Times New Roman", serif;'><span style="font-size:15px;color:#252525;">Pets were important to Sandra and her sisters, and they had a cat and a dog in their family while growing up in Bowmanville.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Asutin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?52c840e3